import type { MainDialogProps } from '@/components/dialogs/mainDialog';
import type { PanelTypes } from '@/components/panels/panelRegistry';

export enum PanelSize {
  Full,
  Large,
}

// Deliberately NOT a PanelSize member: the narrow chat width is reserved for
// the AI assistant sidebar, and an enum value would invite other panels to
// adopt it. Importing this constant is fenced by an eslint
// no-restricted-imports rule to the assistant launcher and getPanelWidth.
export const PanelSizeMedium = 'panelSizeMedium';

export type SidePanelSize = PanelSize | typeof PanelSizeMedium;

export interface SidePanelStore {
  isOpen: boolean;
  isAbsolute: boolean;
  Component: PanelTypes | undefined;
  panelSize: SidePanelSize;
  setSize: (size: SidePanelSize) => void;
  setIsOpen: (
    isOpen: boolean,
    size?: SidePanelSize,
    isAbsolute?: boolean
  ) => void;
  setComponent: (component: PanelTypes) => void;
}

export interface SnackbarStore {
  isOpen: boolean;
  message: React.ReactNode;
  isError?: boolean;
  isWarning?: boolean;
  showMessage: (message: React.ReactNode) => void;
  showErrorMessage: (message: React.ReactNode) => void;
  showWarningMessage: (message: React.ReactNode) => void;
  hide: () => void;
}

export type DialogOptions = Omit<MainDialogProps, 'isOpen' | 'children'>;

export interface DialogEntry extends DialogOptions {
  id: string;
  content: React.ReactNode;
}

export interface DialogStore {
  stack: DialogEntry[];
  open: (id: string, content: React.ReactNode, options?: DialogOptions) => void;
  back: () => void;
  closeAll: () => void;
  replace: (
    id: string,
    content: React.ReactNode,
    options?: DialogOptions
  ) => void;
  isOpen: (id?: string) => boolean;
}

export interface DashboardAiEntryStore {
  isVisible: boolean;
  setIsVisible: (isVisible: boolean) => void;
}

export interface WorkspaceContextValue {
  rightPanel: SidePanelStore;
  snackbar: SnackbarStore;
  sharedDialog: DialogStore;
  dashboardAiEntry: DashboardAiEntryStore;
}
